import React from "react";
import { useParams, Link } from "react-router-dom";
import { setItemInCart } from "./redux/cart/cartSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { CSSTransition } from "react-transition-group";


function ProductItem({ chair }) {
  const { id } = useParams();
  const chairItem = chair.find((item) => String(item.id) === id);
  const dispatch = useDispatch();
  const [showAddedToCart, setShowAddedToCart] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  
  const addInCart = () => {
    dispatch(setItemInCart(chairItem));
    setShowAddedToCart(true);
    setTimeout(() => {
      setShowAddedToCart(false);
    }, 2000);
  };

  if (!chairItem) return null;

  return (
    <div className="min-h-screen bg-[#f6f6f6] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl overflow-hidden">
        {/* Back */}
        <div className="px-6 pt-6">
          <Link
            to="/"
            className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 transition"
          >
            <ion-icon name="arrow-back-outline" class="text-lg"></ion-icon>
            <span className="ml-2">Артка кайтуу</span>
          </Link>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-8 px-6 pb-8 pt-6">
          {/* Image */}
          <div className="flex items-center justify-center bg-gray-100 rounded-xl p-4">
            <img
              src={chairItem.img}
              alt={chairItem.title}
              onClick={() => setIsOpen(true)}
              className="w-full h-[360px] object-cover rounded-xl cursor-zoom-in hover:scale-105 transition"
            />
          </div>

          {/* Info */}
          <div className="flex flex-col justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                {chairItem.title}
              </h1>

              <p className="text-gray-600 mt-4 leading-relaxed">
                {chairItem.subtext}
              </p>

              <div className="flex items-end gap-2 mt-8">
                <span className="text-4xl font-bold text-[#2A254B]">
                  {chairItem.price}
                </span>
                <span className="text-lg font-semibold text-[#2A254B]">
                  сом
                </span>
              </div>
            </div>

            <button
              onClick={addInCart}
              className="mt-10 w-full bg-[#A1C349] hover:bg-[#9ab556] text-white py-4 rounded-xl text-lg font-semibold transition shadow-md hover:shadow-lg"
            >
              Корзинага кошуу
              <CSSTransition
                in={showAddedToCart}
                timeout={200}
                classNames="fade-in"
                unmountOnExit
              >
                <div className="added-to-cart">Себетке кошулду</div>
              </CSSTransition>
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed full inset-0 z-50 bg-black/80 flex items-center justify-center px-4"
        >
          <img
            src={chairItem.img}
            alt={chairItem.title}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-full rounded-xl shadow-2xl cursor-zoom-out"
          />

          {/* Close button */}
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-6 right-6 text-white text-3xl hover:scale-110 transition"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}

export default ProductItem;
